export const theme = {
  colors: {
    white: "#FFFFFF",
    black: "#000000",
    blackOpacity: "rgba(0, 0, 0, 0.1)",
    text: "#564040",
    grey: "#FFFBF4",
    red_grey: "#3F3737",
    granat: "#B40220",
    back_green: "#4D6B6C",
  },
  fonts: ["Fira Sans Condensed", "Roboto Condensed", "Spectral"],
  breakpoints: {
    mobile: "375px",
    tablet: "768px",
    desktop: "1440px",
    mobile_max: "374.98px",
    tablet_max: "767.98px",
    desktop_max: "1439.98px",
  },
  fontSizes: {
    extrasmall: "10px",
    small: "14px",
    small_medium: "16px",
    medium: "18px",
    large: "20px",
    extraX: "24px",
    extraXL: "32px",
    extraXXL: "36px",
  },
  transition: ["all 0.25s ease-in", "all 150ms linear", "all 5s ease"],
  scale: ["scale(1.1)"],
};
